export default __webpack_public_path__ + "i18n/translations/translation-ml.28b78498.json";